import { SnackContext } from "./SnackProvider";
import { useContext } from "react";

const useSnackbar = () => useContext(SnackContext);
export default useSnackbar;
